import { render } from "./saml.vue?vue&type=template&id=57475765&scoped=true"
import script from "./saml.vue?vue&type=script&lang=js"
export * from "./saml.vue?vue&type=script&lang=js"

import "./saml.vue?vue&type=style&index=0&id=57475765&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57475765"]])

export default __exports__